<template>
  <button
    :class="[
      'font-semibold px-4 py-2 rounded-md',
      bgColor,
      textColor,
      additionalClasses,
    ]"
    :data-testid="dataTestId"
    @click="handleClick"
  >
    {{ label }}
  </button>
</template>

<script setup>
defineProps({
  label: {
    type: String,
    required: true,
  },
  bgColor: {
    type: String,
    default: "bg-teal-900",
  },
  textColor: {
    type: String,
    default: "text-white",
  },
  additionalClasses: {
    type: String,
    default: "",
  },
  dataTestId: {
    type: String,
    required: true,
  },
});

const emit = defineEmits(["click"]);

const handleClick = () => {
  emit("click");
};
</script>
